import React, { useEffect, useState } from "react";
import Button from "../Button/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { KeyboardArrowUp } from "@mui/icons-material";
interface PanelProps {
  title?: string;
  children?: React.ReactNode;
  isExpandable?: boolean;
  panelActions?: React.ReactNode;
  isExpanded?: boolean;
  onExpand?: () => void;
}

const Panel = (props: PanelProps) => {
  const {
    title,
    children,
    isExpandable = true,
    panelActions,
    isExpanded,
    onExpand,
  } = props;

  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (isExpanded !== undefined) {
      setExpanded(isExpanded);
    }
  }, [isExpanded]);

  const handleExpand = () => {
    if (onExpand) {
      onExpand();
    }
    setExpanded(!expanded);
  };

  return (
    <div className="dui-panel">
      <div className="dui-panel-top">
        <div className="dui-panel-title">{title}</div>
        <div className="dui-panel-actions">
          {panelActions}
          {isExpandable && (
            <Button
              type="text"
              icon={expanded ? <KeyboardArrowUp /> : <KeyboardArrowDownIcon />}
              onClick={handleExpand}
            />
          )}
        </div>
      </div>
      {expanded ? <div className="dui-panel-content">{children}</div> : null}
    </div>
  );
};

export default Panel;
